import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  DialogContentText,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { PrimaryButton, SecondaryButton, InputText} from '@loanbossinc/component-library'
import styled from 'styled-components';

const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

const StyledDialogContent = styled(DialogContent)`
  && {
    padding-right: 60px;
    color: #666;
  }
`;
const StyledInputText = styled(InputText)`&& {
    width: 510px;
    }`;
export default class FileRenameModal extends React.Component {
    state ={
        fileName:""
    }

    updateFileName = (event) => {
        const newName = event?.target?.value;
        this.setState({fileName: newName});
    }

    acceptNewName = () => {
        let file  = this.props.file;
        file.name = this.state.fileName;
        this.props.onAccept(file);
    }

  render() {
    const { isOpen, onClose, onAccept, file } = this.props;
    return (
      <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>Update File Name</DialogTitle>
        <StyledDialogIconButton onClick={onClose}>
          <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
        </StyledDialogIconButton>

        <StyledDialogContent>
            <StyledInputText name={"fileRename"} label={"File Name"} defaultValue={file.name} onChange={this.updateFileName} />
        </StyledDialogContent>
        <DialogActions>
          {onClose && <SecondaryButton size={'sm'} onClick={onClose} label="Cancel" style={{'margin-right': '16px'}}/>}
          <PrimaryButton size={'sm'} onClick={this.acceptNewName} label="OK" />
        </DialogActions>
      </Dialog>
    );
  }
}
